<template>
    <PageView>
        <a-spin :spinning="loading">
            <a-card :title="`${id ? '编辑' : '添加'}轮播`">
               
                <a-form :form="form" style="width: 350px">
                    <a-form-item label="名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="[`name`, { rules: [{ required: true, message: '请输入名称' }] }]"
                            placeholder="请输入名称"
                        />
                    </a-form-item>
                    <!-- <a-form-item label="简介" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="[`title`, { rules: [{ required: true, message: '请输入简介' }] }]"
                            placeholder="请输入简介"
                        />
                    </a-form-item> -->
                    <a-form-item label="排序号" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="[`sort`, { rules: [{ required: true, message: '请输入排序' }] }]"
                            placeholder="请输入排序"
                        />
                    </a-form-item>
                </a-form>
                <a-button type="primary" @click="sub">
                    提交
                </a-button>
                <a-button type="primary" @click="$router.back()" style="margin-left:10px">
                    返回
                </a-button>
            </a-card>
        </a-spin>
    </PageView>
</template>

<script>
import GoodsCats from '../../api/GoodsCats.js'
import Home from '../../api/Home.js'
import Problem from "../../api/problem.js"
export default {
    name: 'GoodsCatsEdit',
    data() {
        return {
            form: this.$form.createForm(this),
            loading: this.$route.query.id ? true : false,
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 }
            },
            pic: '',
            status: undefined,
            id: this.$route.query.id || undefined,
            add_time:''
        }
    },
    created(){

    },
    mounted() {
        if (this.id) this.getOne();
        let timestamp = Date.now();
        this.add_time = parseInt(timestamp/1000);
        console.log(timestamp);
    },
    methods: {
        getOne() {
            this.$nextTick(() => {
                let data = this.$route.query.data
                this.pic = data.img
                this.form.setFieldsValue({
                    sort: data.sort,
                    name: data.name,
                    title: data.title
                })
                this.loading = false
            })
        },
       
        sub() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.loading = true
                    if (this.id) {
                        Problem.SaveProblem({ ...values, id: this.id ,add_time:this.add_time})
                            .then(res => {
                                this.loading = false
                                this.$router.back()
                            })
                            .catch(res => {
                                this.loading = false
                            })
                    } else {
                        Problem.AddProblem({ ...values ,add_time:this.add_time})
                            .then(res => {
                                this.loading = false
                                this.$router.back()
                            })
                            .catch(res => {
                                this.loading = false
                            })
                    }
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.imgContaienr {
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px;

    .con {
        height: 300px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            display: block;
            max-height: 100%;
            max-width: 100%;
        }

        .placeText {
            font-size: 20px;
        }
    }
}

.btnCon {
    position: relative;
    overflow: hidden;
    display: inline-block;

    input {
        display: block;
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: red;
        opacity: 0;
    }
}
</style>
